import shuffle from 'hs-lodash/shuffle';
export const getRandomizedIndices = (totalTools, toolsToDisplay, shuffler = shuffle) => {
  return totalTools <= toolsToDisplay ? [...Array(totalTools).keys()] : shuffler([...Array(totalTools).keys()]).slice(0, toolsToDisplay);
};